import moment from 'moment';
import { Location, LocationCore } from 'types/UFOTypes';

export function normalizePhone(phoneNumber: string) {
  return phoneNumber.replace(/^[+\d{1,3}\-\s]*\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, '$1$2$3');
}

const formatLocationCoreAddress = (
  address: LocationCore['address'] | Location['address'] | undefined,
  customerAddr1: LocationCore['customer_addr1'] | undefined,
  customerAddr2: LocationCore['customer_addr2'] | undefined,
) => {
  if (address) {
    return address;
  }

  if (!customerAddr1 && !customerAddr2) {
    return '';
  }

  return [customerAddr1, customerAddr2].filter((addr) => !!addr).join(' ');
};

export function formatAsLocationCoreType(location?) {
  if (location === undefined || location === null || typeof location !== 'object') return null;

  const {
    address,
    customer_addr1,
    customer_addr2,
    customer_name = '',
    customer_number = '',
    customer_type,
    customer_city = '',
    customer_state = '',
    customer_zip = '',
    hold_code = '',
  } = location as Partial<LocationCore>;

  const formattedAddress = formatLocationCoreAddress(address, customer_addr1, customer_addr2);
  const formattedSelectedGrantLocation = {
    address: formattedAddress,
    customer_name,
    customer_number,
    customer_type,
    customer_city,
    customer_state,
    customer_zip,
    hold_code,
  } as LocationCore;

  return formattedSelectedGrantLocation;
}

export function formatPhone(phoneNumber = '', formatString = '(NNN) NNN-NNNN') {
  if (!phoneNumber) return '';
  let normalizedPhoneNumber = phoneNumber;
  normalizedPhoneNumber = normalizePhone(phoneNumber);
  let result = formatString;
  for (const number of normalizedPhoneNumber) {
    result = result.replace('N', number);
  }

  return result;
}

export function isNumber(phoneNumber: string) {
  const reg = /^\d+$/;

  return reg.test(phoneNumber);
}

export function isValidNumber(phoneNumber: string) {
  return isNumber(phoneNumber) && phoneNumber.length === 10;
}

export function formatDate(strDate: string) {
  if (!strDate) return null;
  return moment(strDate).format('MMM D YYYY h:mm A').toString();
}

export function formatShortDateTime(strDate: string) {
  if (!strDate) return null;
  return moment(strDate).format('MM-D-YYYY_h-mm-A').toString();
}

export function formatShortDate(strDate: string) {
  if (!strDate) return null;
  return moment(strDate).format('YYYY-MM-D').toString();
}

export function longDate(strDate: string) {
  if (!strDate) return null;
  return moment(strDate).format('dddd, MMMM Do').toString();
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function formatProfileName(profile: { first_name?: string; last_name?: string } = {}) {
  return `${profile.first_name ?? ''} ${profile.last_name ?? ''}`.trim();
}

export function formatPrice(price: string | number) {
  return Number(price || 0).toFixed(2);
}

export function rgbToRgba(color: string, alpha: number) {
  return color.replace(')', `, ${alpha})`).replace('rgb', 'rgba');
}
